import React, { Component } from 'react'
import { connect } from 'redaction'
import { compose, isSEOPage } from 'common/helpers'

import InsideLayout from 'layouts/InsideLayout/InsideLayout'

import injectGlobals from 'decorators/injectGlobals'

import { WidthContainer } from 'components/_new/layout/widthContainer'
import MainSection from 'components/_new/layout/MainSection/MainSection'

import BrandsPage from 'pages/seo/BrandsPage/BrandsPage'
import CommonPage from 'pages/seo/CommonPage/CommonPage'
import NotePage from 'pages/seo/NotePage/NotePage'


class NoMatch extends Component {

  constructor(props) {
    super()

    const { location: { pathname } } = props

    this.isSEOPage = isSEOPage(pathname)
  }

  componentWillMount() {
    const { setRedirectLink } = this.props

    if (!this.isSEOPage) {
      if (setRedirectLink) {
        setRedirectLink('/404')
      }
      else {
        window.location.href = '/404'
      }
    }
  }

  render() {
    if (!this.isSEOPage) {
      return null
    }

    const { data } = this.props
    const { pathname, values: { noteSlug } = {} } = data

    let pageComponent

    if (pathname === '/brands') {
      pageComponent = BrandsPage
    }
    else if (noteSlug) {
      pageComponent = NotePage
    }
    else {
      pageComponent = CommonPage
    }

    return (
      <InsideLayout withSubHeader>
        <WidthContainer>
          <MainSection>
            {React.createElement(pageComponent, data)}
          </MainSection>
        </WidthContainer>
      </InsideLayout>
    )
  }
}


export default compose(
  injectGlobals(({ setRedirectLink }) => ({
    setRedirectLink,
  })),
  connect({
    data: 'view.seoPage',
  }),
)(NoMatch)
